// extracted by extract-css-chunks-webpack-plugin
module.exports = {"games":"games_dc-2o","swiper":"swiper_kopSh","navigation":"navigation_VrvzF","prev":"prev_Zd64q","next":"next_iEhIv"};